module.exports = __webpack_public_path__ + "static/media/colorado.414b6ecf.png";